/**
 * TypeScript mirror of src/lambda/shared/GoobDoobVtt.Domain/Assets.cs.
 * Keep in lockstep — the HTTP handlers serialise these shapes directly.
 */

export interface AssetRecord {
  fileId: string;
  campaignId: string;
  ownerId: string;
  filename: string;
  contentType: string;
  sizeBytes: number;
  createdAt: number;
  naturalWidth: number;
  naturalHeight: number;
  s3Key: string;
}

export const ALLOWED_ASSET_CONTENT_TYPES = ["image/png", "image/jpeg", "image/webp"] as const;
export type AssetContentType = (typeof ALLOWED_ASSET_CONTENT_TYPES)[number];
export const MAX_ASSET_SIZE_BYTES = 25 * 1024 * 1024;

export function isAllowedAssetContentType(ct: string): ct is AssetContentType {
  return (ALLOWED_ASSET_CONTENT_TYPES as readonly string[]).includes(ct);
}

// -------------------- HTTP wire --------------------

export interface PresignUploadRequest {
  filename: string;
  contentType: string;
  sizeBytes: number;
}

export interface PresignUploadResponse {
  fileId: string;
  uploadUrl: string;
  s3Key: string;
  expiresAt: number;
}

export interface CommitUploadRequest {
  naturalWidth: number;
  naturalHeight: number;
}

export interface AssetWithUrl {
  record: AssetRecord;
  downloadUrl: string;
}

export interface ListAssetsResponse {
  assets: AssetWithUrl[];
}
